<div class="companies-administration-container container">
  <div class="page-header container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div fxLayout="column">
      <h1 class="mat-h1 color-primary text-small-caps no-bottom-margin">{{ 'COMPANIES_ADMIN.TITLE' | translate }}</h1>
      <span class="tab-description color-muted">{{ 'COMPANIES_ADMIN.DESCRIPTION' | translate }}</span>
    </div>
    <div fxFlex></div>
    <mtn-icon-button color="accent" [disabled]="true" matTooltip="Feature disabled for Insights entitlements">
      <fa-icon icon="plus"></fa-icon>
    </mtn-icon-button>
    <mtn-text-field [form]="filterForm" controlName="filter" placeholder="{{ 'COMPANIES_ADMIN.FILTER' | translate }}" mtnAnalyticsEventTrigger
                    analyticsEventBind="blur" [analyticsEventName]="AnalyticsEventType.TOUCH_FORM_FIELD"
                    [analyticsEventParameters]="{'target': 'filter'}" [noErrorPadding]="true"></mtn-text-field>
  </div>
  <div class="table-container container">
    <mtn-spinner [size]="SpinnerSize.LARGE" #companiesSpinner></mtn-spinner>
    <div class="no-data-container" fxLayout="row" fxLayoutAlign="center center" *ngIf="!isLoading && !dataSource?.data?.length">{{ 'COMPANIES_ADMIN.NO_RESULTS' | translate }}</div>
    <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc"
           [hidden]="!dataSource?.data?.length">

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'COMPANIES_ADMIN.NAME' | translate }}</th>
        <td mat-cell *matCellDef="let company">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <mtn-company-initials-avatar [company]="company"></mtn-company-initials-avatar>
            <div>
              <div class="company-name">{{ company.name }}</div>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Unique Identifier Column -->
      <ng-container matColumnDef="identifier">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'COMPANIES_ADMIN.IDENTIFIER' | translate }}</th>
        <td mat-cell *matCellDef="let company">
          <div>{{ company.uniqueIdentifier }}</div>
        </td>
      </ng-container>

      <!-- License Column -->
      <ng-container matColumnDef="license">
        <th class="column-center" mat-header-cell *matHeaderCellDef>{{ 'COMPANIES_ADMIN.LICENSE' | translate }}</th>
        <td mat-cell *matCellDef="let company">
          <span>{{ getLicenseDisplayName(company.license.type) }}</span>
        </td>
      </ng-container>

      <!-- License Expiration Column -->
      <ng-container matColumnDef="licenseExpiration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'COMPANIES_ADMIN.LICENSE_EXPIRATION' | translate }}</th>
        <td mat-cell *matCellDef="let company">
          <div *ngIf="company.license.expirationDate; else nonExpiring">
            {{ company.license.expirationDate | insightsDate }}
          </div>
          <ng-template #nonExpiring>
            <div class="color-muted">{{ 'COMPANIES_ADMIN.NON_EXPIRING' | translate }}</div>
          </ng-template>
        </td>
      </ng-container>

      <!-- License Status Column -->
      <ng-container matColumnDef="licenseStatus">
        <th class="column-center" mat-header-cell *matHeaderCellDef>{{ 'COMPANIES_ADMIN.LICENSE_STATUS' | translate }}</th>
        <td mat-cell *matCellDef="let company">
          <span class="color-success" *ngIf="company.license.isValid()">{{ 'COMPANIES_ADMIN.ACTIVE' | translate }}</span>
          <span class="color-error" *ngIf="company.license.isExpired()">{{ 'COMPANIES_ADMIN.EXPIRED' | translate }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="clickable" *matRowDef="let row; columns: displayedColumns;"
          (click)="navigateToCompanyDetails(row)"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center" colspan="3">
          <strong>0</strong> {{ 'COMPANIES_ADMIN.RESULTS_MATCH' | translate }} <strong>{{ dataSource?.data?.length }}</strong>
        </td>
      </tr>
    </table>
    <mat-paginator [pageSize]="25" [length]="totalResults" [pageIndex]="currentPage"
                   [showFirstLastButtons]="true" [hidePageSize]="true" [hidden]="totalResults <= 25"></mat-paginator>
  </div>
</div>
